/**
 * Liability accounts use a counter-intuitive sign convention server-side:
 *   - "income" raises the stored balance (more debt)
 *   - "expense" lowers it (debt reduction)
 *
 * Users expect the opposite: "Income" on a credit card = payment/refund (debt down),
 * "Expense" = interest/charge (debt up). To keep the backend untouched we swap the
 * label at the presentation boundary — read swap when listing, write swap when
 * submitting.
 *
 * Asset accounts are unaffected.
 */

const FLIP = { income: 'expense', expense: 'income' };

/**
 * Translate a DB-stored transaction_type into what the UI should display,
 * given the account kind ('asset' | 'liability' | undefined).
 */
export const toUIType = (dbType, kind) => {
  if (kind === 'liability' && dbType && FLIP[dbType]) return FLIP[dbType];
  return dbType;
};

/**
 * Translate a UI-selected transaction_type into the value to persist server-side,
 * given the account kind.
 */
export const toDBType = (uiType, kind) => {
  if (kind === 'liability' && uiType && FLIP[uiType]) return FLIP[uiType];
  return uiType;
};

/** Convenience: signed multiplier (+1 / -1) for the UI-perspective type. */
export const uiSignMultiplier = (dbType, kind) =>
  toUIType(dbType, kind) === 'income' ? 1 : -1;
